"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBundleName = exports.getBundleExtension = exports.getModuleIdFromBundle = exports.getBundleName = exports.BUNDLE_PREFIX = void 0;
exports.BUNDLE_PREFIX = 'rb_'; // means "registry bundle"
exports.getBundleName = function (props) {
    var componentName = props.componentName, part = props.part, _a = props.namespace, namespace = _a === void 0 ? '' : _a, host = props.host, batch = props.batch, _b = props.extension, extension = _b === void 0 ? 'js' : _b;
    var middle = batch ? host + "_" + batch : host;
    if (componentName && part) {
        return "" + exports.BUNDLE_PREFIX + namespace + "." + middle + "[" + componentName + "]" + part + "." + extension;
    }
    else if (componentName) {
        return "" + exports.BUNDLE_PREFIX + namespace + "." + middle + "[" + componentName + "]." + extension;
    }
    else {
        return "" + exports.BUNDLE_PREFIX + namespace + "." + middle + "." + extension;
    }
};
exports.getModuleIdFromBundle = function (bundleName, extension) {
    return bundleName.replace("." + extension, '');
};
exports.getBundleExtension = function (bundleName) {
    var parsed = bundleName.match(/\.([a-z]+)$/);
    if (!parsed) {
        return null;
    }
    return parsed[1];
};
var getEmptyResult = function () { return ({
    host: undefined,
    namespace: undefined,
    componentName: undefined,
    part: undefined,
    id: undefined,
    extension: undefined,
    batch: undefined,
}); };
exports.parseBundleName = function (bundleName) {
    if (!bundleName.startsWith(exports.BUNDLE_PREFIX)) {
        return getEmptyResult();
    }
    // const raw = bundleName.replace(BUNDLE_PREFIX, '');
    var extension = exports.getBundleExtension(bundleName);
    if (!extension) {
        return getEmptyResult();
    }
    var bundleId = exports.getModuleIdFromBundle(bundleName, extension);
    /**
     * rb_namespace.host
     * rb_namespace.host[componentName]
     * rb_namespace.host[componentName]part
     *
     * Original RegExp with the named groups:
     *
     * /(?<namespace>[^[]+)\.(?<host>[^[]+)(\[(?<componentName>.+)\])?(?<part>[^.]+)?/
     *
     * Some browser still does not support it
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp
     * see `lookbehind assertions` section
     */
    // _____________ns[1]____host[2]___name[4]__part[5]
    var result = /([^[]+)\.([^[]+)(\[(.+)\])?([^.]+)?/.exec(bundleId);
    if (!result) {
        return getEmptyResult();
    }
    var prefixAndNamespace = result[1], hostWithBatch = result[2], componentName = result[4], part = result[5];
    var _a = hostWithBatch.split('_'), host = _a[0], batch = _a[1];
    var namespace = prefixAndNamespace.replace(exports.BUNDLE_PREFIX, '');
    if (batch && (componentName || part)) {
        return getEmptyResult();
    }
    return {
        namespace: namespace ? namespace : undefined,
        host: host,
        componentName: componentName,
        part: part,
        extension: extension,
        batch: batch,
        id: bundleId,
    };
};
//# sourceMappingURL=bundles.js.map